exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropzone{\n\tpadding: 0;\n\tmargin: 0;\n}\n.media-item{\n\toverflow: hidden;\n\theight: 244px;\n}\n#easel-file-picker.media-manager .easel-file-browser .easel-file-picker-list{\n\theight: auto;\n\toverflow-y: visible;\n}\n#easel-file-picker .easel-file-browser{\n\theight: 60vh;\n}\n", ""]);

// exports
